__turbopack_context__.v({
  "Delbtn": "otp-module__DaBwtG__Delbtn",
  "delaccContent": "otp-module__DaBwtG__delaccContent",
  "dontmatch": "otp-module__DaBwtG__dontmatch",
  "heaing": "otp-module__DaBwtG__heaing",
  "otpfield": "otp-module__DaBwtG__otpfield",
  "otpfieldList": "otp-module__DaBwtG__otpfieldList",
  "otpfieldListError": "otp-module__DaBwtG__otpfieldListError",
  "register": "otp-module__DaBwtG__register",
  "resenTime": "otp-module__DaBwtG__resenTime",
  "resendotp": "otp-module__DaBwtG__resendotp",
  "resendotpSpam": "otp-module__DaBwtG__resendotpSpam",
  "signupreset": "otp-module__DaBwtG__signupreset",
  "titcenter": "otp-module__DaBwtG__titcenter",
  "verified": "otp-module__DaBwtG__verified",
});
